import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString } from 'class-validator';
import { IsPhoneNumberWithLVS } from '@goparrot/common';
import { SquareLoyaltyExposeGroup } from '../interface';
export class CreateSquareLoyaltyAccountDto {
}
__decorate([
    Expose({ groups: [SquareLoyaltyExposeGroup.CREATE] }),
    IsString({ always: true }),
    IsPhoneNumberWithLVS(undefined, { always: true }),
    ApiProperty({ type: () => String, description: 'Phone number' }),
    __metadata("design:type", String)
], CreateSquareLoyaltyAccountDto.prototype, "phoneNumber", void 0);
__decorate([
    Expose({ groups: [SquareLoyaltyExposeGroup.CREATE] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    ApiProperty({ type: () => String, description: 'Square customer id' }),
    __metadata("design:type", String)
], CreateSquareLoyaltyAccountDto.prototype, "customerId", void 0);
//# sourceMappingURL=CreateSquareLoyaltyAccountDto.js.map